// Function to return the initial options
import { ActivityComparisonOptions } from "./activity-comparison/types";
import InstanceTarget from "../../types/instance/InstanceTarget";
import { getDefaultPeriodDates, getTimeZone } from "../../helpers/utils";

export const getComparisonInitialOptions = (instances: InstanceTarget[], hasMetric: boolean): ActivityComparisonOptions => {
    const searchParams = new URLSearchParams(window.location.search);
    const tz = getTimeZone();
    const defaults = getDefaultPeriodDates(tz);

    const getInstanceName = (id: any) => {
        const instance = instances.find(instance => instance.id === parseInt(id ?? '-1', 10));
        return instance ? instance.name : '';
    };

    const metric = hasMetric ? searchParams.get('metric') : 'waittime';

    const values = {
        aggregate: 'auto',
        compare: searchParams.get('compare') || 'sql',
        metric: metric || '',
        chart: searchParams.get('chart') || 'column',
        topN: parseInt(searchParams.get('topN') || '10', 10) || 10,
        tagName: searchParams.get('tagName') || undefined,
        other: searchParams.get('other') === 'true',
        showSqlId: searchParams.get('showSqlId') === 'true',
        customSqlId: searchParams.get('customId') || '',
        firstInstanceOptions: {
            instanceId: parseInt(searchParams.get('firstInstanceId') ?? '-1', 10) || -1,
            instanceType: undefined,
            periodStart: searchParams.get('firstInstanceFrom') ? new Date(searchParams.get('firstInstanceFrom')!) : defaults.firstPeriodStart,
            periodEnd: searchParams.get('firstInstanceTo') ? new Date(searchParams.get('firstInstanceTo')!) : defaults.firstPeriodEnd,
            instanceName: getInstanceName(searchParams.get('firstInstanceId')),
            snapshotId: Number(searchParams.get('firstInstanceSnapshotId')) || undefined,
        },
        secondInstanceOptions: {
            instanceId: parseInt(searchParams.get('secondInstanceId') ?? '-1', 10) || -1,
            instanceType: undefined,
            periodStart: searchParams.get('secondInstanceFrom') ? new Date(searchParams.get('secondInstanceFrom')!) : defaults.secondPeriodStart,
            periodEnd: searchParams.get('secondInstanceTo') ? new Date(searchParams.get('secondInstanceTo')!) : defaults.secondPeriodEnd,
            instanceName: getInstanceName(searchParams.get('secondInstanceId')),
            snapshotId: Number(searchParams.get('secondInstanceSnapshotId')) || undefined,
        },
    };

    return values
};

export const resetComparisonInitialOptions = (hasMetric: boolean): ActivityComparisonOptions => {
    const defaults = getDefaultPeriodDates(getTimeZone());

    return {
        aggregate: 'auto',
        compare: 'sql',
        metric: hasMetric ? '' : 'waittime',
        chart: 'column',
        topN: 10,
        tagName: undefined,
        other: false,
        showSqlId: false,
        customSqlId: '',
        firstInstanceOptions: {
            instanceId: -1,
            instanceType: undefined,
            periodStart: defaults.firstPeriodStart,
            periodEnd: defaults.firstPeriodEnd,
            instanceName: '',
            snapshotId: undefined,
        },
        secondInstanceOptions: {
            instanceId: -1,
            instanceType: undefined,
            periodStart: defaults.secondPeriodStart,
            periodEnd: defaults.secondPeriodEnd,
            instanceName: '',
            snapshotId: undefined,
        },
    };
};
